import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { addAppliedFilters, updateUriRef } from '../../actions/filterActions';
import { updateRelayVariables } from '../../actions/sharedRelayVariableActions';
import get from 'lodash.get';
import { FindingRouter } from '../../router/FindingRouter';
import { searchBrowse as routes } from '../../router/routes/searchBrowse';
import { stripRoutingSegment, addCdnQueryParams } from '../../utils/uriUtils';
import { toggleRequestInFlight } from '../../actions/filterActions';
import { getFollowTypeFromUri } from '../../utils/favoritesUtils';

export class SbSharedRefetchContainerComponent extends React.Component {
    constructor() {
        super();
        this.refetchCallback = this.refetchCallback.bind(this);
    }

    componentWillMount() {
        // set applied filters in reducer :
        const appliedFilters = this.props.searchBrowse.appliedFilters;
        this.props.addAppliedFilters(appliedFilters);
    }

    componentDidMount() {
        this.initRouter();
    }

    componentWillReceiveProps(nextProps) {
        const { generatedUriRef, page: newPage, onSbRefetch, pageSize: newPageSize } = nextProps;
        /**
         * Make sure we have query params in both uri refs before comparing them to see if they've
         * changed.
         */
        const oldUriRef = addCdnQueryParams(this.props.generatedUriRef);
        const newUriRef = addCdnQueryParams(generatedUriRef);
        const redirectTo = get(nextProps, 'searchBrowse.spellCheck.redirect.redirectTo');

        if ((oldUriRef !== '' && newUriRef !== oldUriRef) || newPageSize !== this.props.pageSize) {
            const variables = {
                // if uriRef changed because filter added/removed, reset to page 1
                page: newPage === this.props.page ? 1 : newPage,
                uriRef: newUriRef,
                followSearchPages: [generatedUriRef],
                followSearchTypes: [getFollowTypeFromUri(generatedUriRef)],
                first: newPageSize,
            };
            // 1. set state to loading
            nextProps.toggleRequestInFlight(true);

            // 2. do refetch
            onSbRefetch(variables, null, this.refetchCallback);

            // 3. update to new relay vars
            nextProps.updateRelayVariables(variables);
        }

        if (redirectTo) {
            this.router.navigate(redirectTo);
        }
    }

    refetchCallback() {
        const displayUriRef = get(this.props, 'searchBrowse.displayUriRef');
        const newAppliedFilters = get(this.props, 'searchBrowse.appliedFilters');

        this.props.toggleRequestInFlight(false);

        this.props.addAppliedFilters(newAppliedFilters);

        if (displayUriRef) {
            this.router.navigate(displayUriRef);
        }
    }

    initRouter() {
        this.router = new FindingRouter({ routes });
        this.router.history.listen(({ pathname, search }, action) => {
            if (action === 'POP') {
                const uriRef = `${pathname}${search}`;
                this.props.updateUriRef(stripRoutingSegment(uriRef));
            }
        });
    }

    render() {
        return null;
    }
}

SbSharedRefetchContainerComponent.propTypes = {
    updateUriRef: PropTypes.func.isRequired,
    addAppliedFilters: PropTypes.func.isRequired,
    onSbRefetch: PropTypes.func.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    // TODO INFRA: Should be required
    generatedUriRef: PropTypes.string,
    toggleRequestInFlight: PropTypes.func.isRequired,
    updateRelayVariables: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    const { filters, relayVariables } = state;
    const { generatedUriRef, page } = filters;
    const {
        variables: { first },
    } = relayVariables;
    return {
        page,
        generatedUriRef,
        pageSize: first,
    };
}

export const SbSharedRefetchContainer = createFragmentContainer(
    connect(
        mapStateToProps,
        {
            addAppliedFilters,
            updateUriRef,
            updateRelayVariables,
            toggleRequestInFlight,
        }
    )(SbSharedRefetchContainerComponent),
    {
        searchBrowse: graphql`
            fragment SbSharedRefetchContainer_searchBrowse on SearchBrowseQueryConnection {
                displayUriRef
                spellCheck {
                    redirect {
                        redirectTo
                    }
                }
                appliedFilters {
                    name
                    rank
                    values {
                        displayName
                        urlLabel
                        code
                    }
                }
            }
        `,
    }
);
